import { render, staticRenderFns } from "./EventCollateralAction.vue?vue&type=template&id=4eaa5e86&scoped=true&"
import script from "./EventCollateralAction.vue?vue&type=script&lang=js&"
export * from "./EventCollateralAction.vue?vue&type=script&lang=js&"
import style0 from "./EventCollateralAction.vue?vue&type=style&index=0&id=4eaa5e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa5e86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
